import fileDownload from 'js-file-download'
import ExcelJS from 'exceljs'
import utils from '../../../utils'

export const exportAssetStatisticsExcel = async (record, currentDate) => {
  try {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Thống kê tài sản')

    worksheet.getColumn('A').width = 5 //stt
    worksheet.getColumn('B').width = 40 // Tên dụng cụ
    worksheet.getColumn('C').width = 15 // đơn vị tính
    worksheet.getColumn('D').width = 10 // thuế
    worksheet.getColumn('E').width = 15 // đơn giá trước thuế
    worksheet.getColumn('F').width = 15 // đơn giá sau thuế
    worksheet.getColumn('G').width = 10 // tồn đầu kỳ - số lượng
    worksheet.getColumn('H').width = 15 // thành tiền trước thuế
    worksheet.getColumn('I').width = 15 // thành tiền sau thuế
    worksheet.getColumn('J').width = 10 // nhập trong kỳ - số lượng
    worksheet.getColumn('K').width = 15 // thành tiền trước thuế
    worksheet.getColumn('L').width = 15 // thành tiền sau thuế
    worksheet.getColumn('M').width = 10 // xuất trong kỳ - số lượng
    worksheet.getColumn('N').width = 15 // thành tiền trước thuế
    worksheet.getColumn('O').width = 15 // thành tiền sau thuế
    worksheet.getColumn('P').width = 10 // tồn cuối kỳ - số lượng
    worksheet.getColumn('Q').width = 15 // thành tiền trước thuế
    worksheet.getColumn('R').width = 15 // thành tiền sau thuế

    // Thêm tiêu đề và các thông tin khác
    worksheet.mergeCells('A1:R2') // Merge từ A1 đến R2
    worksheet.getCell(
      'A1'
    ).value = `THỐNG KÊ NHẬP XUẤT TỒN VĂN PHÒNG PHẨM THÁNG ${currentDate}`

    worksheet.getCell('A1').alignment = {
      vertical: 'middle',
      horizontal: 'center',
    }

    worksheet.getCell('A1').font = { size: 14, bold: true }

    const headerNameRowOne = [
      'Số TT',
      'Tên dụng cụ, văn phòng phẩm',
      'Đơn vị tính',
      'Thuế',
      'Đơn giá trước thuế',
      'Đơn giá sau thuế',
      'TỒN ĐẦU KỲ',
      '',
      '',
      'NHẬP TRONG KỲ',
      '',
      '',
      'XUẤT TRONG KỲ',
      '',
      '',
      'TỒN CUỐI KỲ',
      '',
      '',
    ]
    const headerNameRowTwo = [
      '',
      '',
      '',
      '',
      '',
      '',
      'Số lượng',
      'Thành tiền trước thuế',
      'Thành tiền sau thuế',
      'Số lượng',
      'Thành tiền trước thuế',
      'Thành tiền sau thuế',
      'Số lượng',
      'Thành tiền trước thuế',
      'Thành tiền sau thuế',
      'Số lượng',
      'Thành tiền trước thuế',
      'Thành tiền sau thuế',
    ]

    worksheet.addRow(headerNameRowOne)
    worksheet.addRow(headerNameRowTwo)
    worksheet.mergeCells('A3:A4')
    worksheet.mergeCells('B3:B4')
    worksheet.mergeCells('C3:C4')
    worksheet.mergeCells('D3:D4')
    worksheet.mergeCells('E3:E4')
    worksheet.mergeCells('F3:F4')
    worksheet.mergeCells('G3:I3')
    worksheet.mergeCells('J3:L3') // Merging for 'Phí sửa chữa CONT (hạng mục thu)'
    worksheet.mergeCells('M3:O3')
    worksheet.mergeCells('P3:R3')

    // Áp dụng border cho các ô tiêu đề
    const borderStyle = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }

    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = borderStyle
      })
    })

    // Áp dụng border cho từng ô trong dòng tiêu đề đầu tiên
    headerNameRowOne.forEach((_, colIndex) => {
      worksheet.getCell(3, colIndex + 1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }
      worksheet.getCell(3, colIndex + 1).font = { bold: true }
    })

    // Áp dụng border cho từng ô trong dòng tiêu đề thứ hai
    headerNameRowTwo.forEach((_, colIndex) => {
      worksheet.getCell(4, colIndex + 1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
      }
      worksheet.getCell(4, colIndex + 1).font = { bold: true }
    })

    const selectAssetStatistics = (record, type, isSameMonth) => {
      const [compareMonth] = currentDate.split('-')
      const itemLastMonth = record?.assetHistories?.filter(item => {
        const itemDate = new Date(item?.applyAt)
        return (
          item?.type === type &&
          ((isSameMonth && itemDate.getMonth() + 1 == compareMonth) ||
            (!isSameMonth && itemDate.getMonth() + 1 != compareMonth))
        )
      })
      const resultLastMonth =
        itemLastMonth?.length > 0 ? itemLastMonth[0] : null

      return resultLastMonth
    }

    let currentIndex = 1

    if (record) {
      let openBalBeforeTax = 0 //Tổng cộng tiền trước thuế tồn đầu kỳ
      let openBalAfterTax = 0 //Tổng cộng tiền sau thuế tồn đầu kỳ
      let importBeforeTax = 0 // Tổng cộng tiền trước thuế nhập trong kỳ
      let importAfterTax = 0 // Tổng cộng tiền sau thuế nhập trong kỳ
      let exportBeforeTax = 0 // Tổng cộng tiền trước thuế xuất trong kỳ
      let exportAfterTax = 0 // Tổng cộng tiền sau thuế xuất trong kỳ
      let closeBalBeforeTax = 0 // Tổng cộng tiền trước thuế tồn cuối kỳ
      let closeBalAfterTax = 0 // Tổng cộng tiền sau thuế tồn cuối kỳ
      Object.keys(record).forEach(category => {
        const categoryRow = worksheet.addRow([null, category.toUpperCase()])
        categoryRow.font = { bold: true }

        let totalMoneyOpeningPriceSum = 0 // Tổng tiền trước thuế tồn đầu kỳ
        let totalMoneyOpeningSum = 0 // Tổng tiền sau thuế tồn đầu kỳ
        let totalMoneyPeriodImportPriceSum = 0 // Tổng tiền trước thuế nhập trong kỳ
        let totalMoneyPeriodImportSum = 0 // Tổng tiền sau thuế nhập trong kỳ
        let totalMoneyPeriodExportPriceSum = 0 // Tổng tiền trước thuế xuất trong kỳ
        let totalMoneyPeriodExportSum = 0 // Tổng tiền sau thuế xuất trong kỳ
        let totalMoneyFinalPriceSum = 0 // Tổng tiền trước thuế tồn cuối kỳ
        let totalMoneyFinalSum = 0 // Tổng tiền sau thuế tồn cuối kỳ

        record[category]
          .sort((a, b) =>
            utils.compareVietnameseName(a.asset?.assetName, b.asset?.assetName)
          )
          // .filter(item => item?.asset)
          .forEach((item, index) => {
            const periodImportQuantity =
              item?.assetHistories?.reduce((quantity, imports) => {
                if (imports?.type === 'CREATE' || imports?.type === 'UPDATE') {
                  quantity += imports.quantity
                }
                return quantity
              }, 0) || 0
            const periodExportQuantity =
              item?.assetHistories?.reduce((quantity, exports) => {
                if (exports?.type === 'EXPORT') {
                  quantity += exports.quantity
                }
                return quantity
              }, 0) || 0
            const itemUpdateLast = item?.assetHistories
              ?.filter(item => item?.type !== 'LASTMONTH')
              .reduce((latestItem, currentItem) => {
                if (
                  !latestItem ||
                  new Date(currentItem.applyAt) > new Date(latestItem.applyAt)
                ) {
                  return currentItem
                }
                return latestItem
              }, null)

            const preStore = selectAssetStatistics(item, 'LASTMONTH', false)
            const lastStore = selectAssetStatistics(item, 'LASTMONTH', true)

            const price =
              item?.asset?.price ||
              preStore?.price ||
              itemUpdateLast?.price ||
              0
            const tax = item?.asset?.tax || 0
            const totalMoney = (price * (tax + 100)) / 100

            totalMoneyOpeningPriceSum += preStore?.quantity * price || 0
            openBalBeforeTax += preStore?.quantity * price || 0
            totalMoneyOpeningSum += preStore?.quantity * totalMoney || 0
            openBalAfterTax += preStore?.quantity * totalMoney || 0

            // Tính toán tổng tiền  trước thuế nhập trong kỳ
            const totalMoneyPeriodImport = periodImportQuantity * price || 0
            totalMoneyPeriodImportPriceSum += totalMoneyPeriodImport
            importBeforeTax += totalMoneyPeriodImport

            // Tính toán tổng tiền sau thuế nhập trong kỳ
            const moneyPeriodImport = periodImportQuantity * totalMoney || 0
            totalMoneyPeriodImportSum += moneyPeriodImport
            importAfterTax += moneyPeriodImport

            // Tính toán tổng tiền  trước thuế xuất trong kỳ
            const totalMoneyPeriodExport = periodExportQuantity * price || 0
            totalMoneyPeriodExportPriceSum += totalMoneyPeriodExport
            exportBeforeTax += totalMoneyPeriodExport

            // Tính toán tổng tiền sau thuế xuất trong kỳ
            const moneyPeriodExport = periodExportQuantity * totalMoney || 0
            totalMoneyPeriodExportSum += moneyPeriodExport
            exportAfterTax += moneyPeriodExport

            // Tính toán tổng tiền  trước thuế tồn cuối kỳ
            totalMoneyFinalPriceSum += lastStore?.quantity * price || 0
            closeBalBeforeTax += lastStore?.quantity * price || 0

            // Tính toán tổng tiền sau thuế tồn cuối kỳ
            totalMoneyFinalSum += lastStore?.quantity * totalMoney || 0
            closeBalAfterTax += lastStore?.quantity * totalMoney || 0

            const rowData = [
              currentIndex++,
              item?.asset?.assetName,
              item?.asset?.assetUnitName,
              `${tax}%`,
              price,
              totalMoney,
              preStore?.quantity || 0, // tồn đầu kỳ
              preStore?.quantity * price || 0,
              preStore?.quantity * totalMoney || 0,
              periodImportQuantity, // nhập trong kỳ
              periodImportQuantity * price,
              periodImportQuantity * totalMoney,
              periodExportQuantity, // xuất trong kỳ
              periodExportQuantity * price,
              periodExportQuantity * totalMoney,
              lastStore?.quantity || 0,
              lastStore?.quantity * price || 0,
              lastStore?.quantity * totalMoney || 0,
            ]

            const rowItem = worksheet.addRow(rowData)
            rowItem.eachCell({ includeEmpty: true }, cell => {
              cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
              }
              cell.alignment = { vertical: 'middle', horizontal: 'center' }
            })

            const leftAlignedColumns = [2, 5, 6, 8, 9, 11, 12, 14, 15, 17, 18]

            worksheet.eachRow((row, rowNumber) => {
              if (rowNumber >= 5) {
                // Chỉ áp dụng từ dòng 5 trở đi
                leftAlignedColumns.forEach(col => {
                  row.getCell(col).alignment = {
                    horizontal: col === 2 ? 'left' : 'right', // Cột B (2) căn trái, các cột khác căn phải
                  }
                  if (col !== 2) {
                    row.getCell(col).numFmt = '#,##0' // Định dạng tiền tệ
                  }
                })
              }
            })
          })

        // Thêm hàng tổng
        const totalRow = worksheet.addRow([
          null,
          `Tổng`,
          null,
          null,
          null,
          null,
          null,
          totalMoneyOpeningPriceSum,
          totalMoneyOpeningSum,
          null,
          totalMoneyPeriodImportPriceSum,
          totalMoneyPeriodImportSum,
          null,
          totalMoneyPeriodExportPriceSum,
          totalMoneyPeriodExportSum,
          null,
          totalMoneyFinalPriceSum,
          totalMoneyFinalSum,
        ])
        totalRow.font = { bold: true }
        totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
          }
          cell.alignment = {
            vertical: 'middle',
            horizontal: colNumber === 2 ? 'left' : 'right',
          }
          const currencyColumns = [8, 9, 11, 12, 14, 15, 17, 18] // Các cột cần định dạng VND
          if (currencyColumns.includes(colNumber)) {
            cell.numFmt = '#,##0' // Định dạng tiền tệ VND
          }
        })
      })

      // Thêm hàng tổng cộng cuối cùng
      const totalRow = worksheet.addRow([
        null,
        `TỔNG CỘNG`,
        null,
        null,
        null,
        null,
        null,
        openBalBeforeTax,
        openBalAfterTax,
        null,
        importBeforeTax,
        importAfterTax,
        null,
        exportBeforeTax,
        exportAfterTax,
        null,
        closeBalBeforeTax,
        closeBalAfterTax,
      ])
      totalRow.font = { bold: true, name: 'Times New Roman' }
      totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' },
        }
        cell.alignment = {
          vertical: 'middle',
          horizontal: colNumber === 2 ? 'center' : 'right',
        }

        // Áp dụng định dạng tiền tệ cho các cột số tiền
        const currencyColumns = [8, 9, 11, 12, 14, 15, 17, 18] // Các cột cần định dạng VND
        if (currencyColumns.includes(colNumber)) {
          cell.numFmt = '#,##0' // Định dạng tiền tệ VND
        }
      })

      const reportCreatorRow = worksheet.addRow([
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        'NGƯỜI LẬP BẢNG',
        null,
        null,
        null,
        null,
      ])

      // Đặt kiểu chữ và căn giữa
      reportCreatorRow.font = { name: 'Times New Roman', size: 14, bold: true }
      reportCreatorRow.alignment = { horizontal: 'center', vertical: 'middle' }
    } else {
      console.error('record.data is not an array or is undefined')
    }

    const filename = `Thong_ke_tai_san_${currentDate}.xlsx`
    const buffer = await workbook.xlsx.writeBuffer()
    fileDownload(buffer, filename)
  } catch (error) {
    console.log('export asset statistic excel', error)
  }
}
